export function useSchemaDownloadText(
  isDownloadable: MaybeRefOrGetter<boolean>,
  isCurated?: MaybeRefOrGetter<boolean>,
  ownerAllowsDownload?: MaybeRefOrGetter<boolean>,
  isOwned?: MaybeRefOrGetter<boolean>
) {
  const { loggedIn } = storeToRefs(useUserStore());
  const { t } = useI18n();
  const schemaDownloadText = computed(() => {
    const messages = {
      loginToDownload: t(
        "legal_text.middleColumn.schema_editor.not_logged_in_tooltip"
      ),
      cannotDownloadCurated: t(
        "legal_text.middleColumn.schema_editor.can_not_download_curated_text"
      ),
      sharedChannelNotAllowed: t(
        "legal_text.middleColumn.schema_editor.not_enabled_shared_channel_text"
      ),
      download: "Download",
    };

    const conditions = {
      notLoggedIn: !loggedIn.value,
      ownedAndDownloadable: toValue(isOwned) && toValue(isDownloadable),
      isCurated: toValue(isCurated),
      ownerDisallowsDownload: !toValue(ownerAllowsDownload),
      downloadable: toValue(isDownloadable),
    };

    switch (true) {
      case conditions.notLoggedIn:
        return messages.loginToDownload;
      case conditions.ownedAndDownloadable:
        return messages.download;
      case conditions.isCurated:
        return messages.cannotDownloadCurated;
      case conditions.ownerDisallowsDownload:
        return messages.sharedChannelNotAllowed;
      default:
        return conditions.downloadable
          ? messages.download
          : messages.cannotDownloadCurated;
    }
  });

  return schemaDownloadText;
}
